import React from "react";
import TopNav from "../../commonUI/TopHeader/TopHeader";
import { toScreen } from "../../../js/modules/Routing";
import withNavigate from "../withNavigate";
import { AccountDeletionsIcons, AnayticsReportIcon, BookingCancellationIcons, MembershipCancellationIcon, MonthlyKPIIcon, NotificationIcon } from "../../../components/commonUI/Icons/SvgIcon";

const ReportsDashboard = (props) => {
  const handleRptCardClick = (actionPath) => {
    const pageUrl = `/reports/${actionPath}`;

    if (actionPath === "monthly") {
      toScreen(false, props.navigate, pageUrl);
    }
    if (actionPath === "booking-cancellations") {
      toScreen(false, props.navigate, pageUrl);
    }
    if (actionPath === "account-deletions") {
      toScreen(false, props.navigate, pageUrl);
    }
      if (actionPath === "membership-cancellations") {
      toScreen(false, props.navigate, pageUrl);
    }
      if (actionPath === "analytics-report") {
      toScreen(false, props.navigate, pageUrl);
    }
     if (actionPath === "notification") {
      toScreen(false, props.navigate, pageUrl);
    }

  };

  return (
    <>
      <TopNav title="Reports" />
      <div className="global-body">
        <div className="global-body-container">
          <div className="rpt-cards-container">
            <div
              className="rpt-card"
              onClick={() => handleRptCardClick("monthly")}
            >
              <div className="rpt-card-icon blue">
                <MonthlyKPIIcon />
              </div>
              <div className="rpt-card-content">
                <h3 className="rpt-card-title">Monthly KPIs</h3>
                <p className="rpt-card-description">Year-at-a-glance table showing all the key metrics</p>
              </div>
            </div>
            <div
              className="rpt-card"
              onClick={() => handleRptCardClick("booking-cancellations")}
            >
              <div className="rpt-card-icon orange">
                <BookingCancellationIcons />
              </div>
              <div className="rpt-card-content">
                <h3 className="rpt-card-title">Booking Cancellations</h3>
                <p className="rpt-card-description">Analyze booking cancellation trends and reasons</p>
              </div>
            </div> 
          <div
              className="rpt-card"
              onClick={() => handleRptCardClick("account-deletions")}
            >
              <div className="rpt-card-icon red">
                <AccountDeletionsIcons />
              </div>
              <div className="rpt-card-content">
                <h3 className="rpt-card-title">Account Deletions</h3>
                <p className="rpt-card-description">Track user account deletion requests and reasons</p>
              </div>
            </div>
              <div
              className="rpt-card"
              onClick={() => handleRptCardClick("membership-cancellations")}
            >
              <div className="rpt-card-icon light-green">
                <MembershipCancellationIcon />
              </div>
              <div className="rpt-card-content">
                <h3 className="rpt-card-title">Membership Cancellations</h3>
                <p className="rpt-card-description">Understand why MAVs cancel their memberships</p>
              </div>
            </div>
              <div
              className="rpt-card"
              onClick={() => handleRptCardClick("analytics-report")}
            >
              <div className="rpt-card-icon light-blue">
                <AnayticsReportIcon />
              </div>
              <div className="rpt-card-content">
                <h3 className="rpt-card-title">Analytics</h3>
                <p className="rpt-card-description">Understand business activity, website traffic and app usage</p>
              </div>
            </div>
              <div
              className="rpt-card"
              onClick={() => handleRptCardClick("notification")}
            >
              <div className="rpt-card-icon light-purple">
                <NotificationIcon />
              </div>
              <div className="rpt-card-content">
                <h3 className="rpt-card-title">Notification</h3>
                <p className="rpt-card-description">Review email, push and SMS notifications and investigate failures</p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default withNavigate(ReportsDashboard);
